import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

// import Slider from 'rc-slider';
// import 'rc-slider/assets/index.css';

// const createSliderWithTooltip = Slider.createSliderWithTooltip;
// const Range = createSliderWithTooltip(Slider.Range);
// const Handle = Slider.Handle;
// -------------------------------------------------------

class Line extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      refresh : false,
      setting_value : []
    };
  }
  // -------------------------------------------------------
  
  /*
   * データの更新
   */
  update(val) {
    let range = this.props.range;
    this.setState({ setting_value: [val[0], val[1]] });
    
    this.props.change_ev.bind(this)(this.props.id +'_min', range[val[0]]);
    this.props.change_ev.bind(this)(this.props.id +'_max', range[val[1]]);
    
  }
  // -------------------------------------------------------
  
  /*
   * 親データの更新時
   */
  componentWillReceiveProps(nextProps) {
    
    let update_flg = true;
    try {
      let val = this.state.setting_value;
      let defaultVal = nextProps.defaultValue;
      
      if( val[0] == defaultVal.min && val[1] == defaultVal.max ) update_flg = false;
    } catch(e) {}
    
    if( update_flg == true ){
      this.setState({ refresh: true });
      setTimeout( function(){ this.setState({ refresh: false }); }.bind(this), 15);
    }
    
  }
  // -------------------------------------------------------
  
  render() {
    let min;
    let max;
    let fmt = this.props.fmt;
    
    if( this.state.refresh == true ) return <div className="rc-slider-box" />;
    
    // レンジ設定
    let range = Object.assign({}, this.props.range);
    for( let val in range ){
      val = parseInt(val);
      if( min == undefined || val < min ) min = val;
      if( max == undefined || val > max ) max = val;
      
      if( fmt != undefined ){
        range[val] = range[val] + fmt;
      } else {
        range[val] = Utils.viewScore(range[val], 0);
        if( range[val] == '100万' ) range[val] = '100万+'
      }
    }
    
    let marks = {};
    for( let val in range ){
      val = parseInt(val);
      if( this.props.points.indexOf(val) !== -1 ) marks[val] = range[val];
    }
    
    // デフォルト設定
    let dmin = min;
    let dmax = max;
    let defaultValue = this.props.defaultValue;
    if( defaultValue != undefined ){
      for( let val in this.props.range ){
        if( defaultValue.min == this.props.range[val] ) dmin = parseInt(val);
        if( defaultValue.max == this.props.range[val] ) dmax = parseInt(val);
      }
    }
    
    if( this.state.setting_value.length > 0 ){
      dmin = parseInt(this.state.setting_value[0]);
      dmax = parseInt(this.state.setting_value[1]);
    } 
    
    return (
      <div className="column">
        <h6>{this.props.name}</h6>
        <div className="rc-slider-box">
          <input
            type         = "range"
            min          = {min}
            max          = {max}
            step         = {1}
            defaultValue = {dmin}
            onChange     = {(e) => this.update.bind(this)([parseInt(e.target.value), dmax])}
          />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Line;